export enum AppContext {
  Public = 0,
  User = 1,
  Admin = 2,
}
